import { render, staticRenderFns } from "./ExpanderComponent.vue?vue&type=template&id=21a7b78e&scoped=true&"
import script from "./ExpanderComponent.vue?vue&type=script&lang=js&"
export * from "./ExpanderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a7b78e",
  null
  
)

export default component.exports